module.exports = __webpack_public_path__ + "static/media/in_out.c1994e5e.png";